import React from 'react';
import PropTypes from 'prop-types';

import { IconFeatured } from '../Icons';
import { StyledDiv, StyledH3 } from './CustomCollectionDetailsStyles';

var _ref = React.createElement(
  'p',
  null,
  React.createElement(IconFeatured, null),
  ' = Shown in collection photo'
);

var CustomCollectionDetails = function CustomCollectionDetails(props) {
  return React.createElement(
    StyledDiv,
    { className: 'custom-collection__step-details' },
    React.createElement(
      StyledH3,
      null,
      props.title.toUpperCase()
    ),
    React.createElement('p', { dangerouslySetInnerHTML: { __html: props.descriptionHtml } }),
    _ref
  );
};

CustomCollectionDetails.propTypes = {
  title: PropTypes.string,
  descriptionHtml: PropTypes.string,
  roomPanoCollectionId: PropTypes.string
};

export default CustomCollectionDetails;